var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-photo-browser',{ref:"pb",attrs:{"id":_vm.id+'pb',"photos":_vm.photos,"backLinkText":_vm.$theme.ios ? _vm.resource.closeBtn : '',"ofText":_vm.resource.ofText,"toolbar":_vm.handleNextPrevToolbar()}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cc54ccd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ImageFullScreen.vue
// module id = null
// module chunks = 